import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import { setDelivery, storeHashKey } from '../action';
import queryString from 'query-string';
import { firstQueryValue } from 'shared/util/queryParams';

function AddressForm(props) {
    const { location } = props;
    const [parsed] = useState(() => queryString.parse(location.search));

    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [title, setTitle] = useState('');
    const [name, setName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [postal, setPostal] = useState('');
    const [area, setArea] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const customerKey = firstQueryValue(parsed.uid);
    const validatorKey = firstQueryValue(parsed.PaymentHashToRedirctPaymentGate);

    const hasValidSessionKeys = useCallback(() => {
        const invalidTokens = ['YOUR_USER_KEY', 'undefined', 'null'];
        const normalizedCustomerKey = String(customerKey ?? '').trim();
        const normalizedValidatorKey = String(validatorKey ?? '').trim();
        return (
            normalizedCustomerKey !== '' &&
            normalizedValidatorKey !== '' &&
            !invalidTokens.includes(normalizedCustomerKey) &&
            !invalidTokens.includes(normalizedValidatorKey)
        );
    }, [customerKey, validatorKey]);

    useEffect(() => {
        navigator.geolocation.getCurrentPosition((position) => {
            setLatitude(String(position.coords.latitude));
            setLongitude(String(position.coords.longitude));
        });
    }, []);

    const validate = useCallback((json) => {
        if (
            json.CustomerKey &&
            json.ValidatorKey &&
            json.Title &&
            json.Name &&
            json.Address1 &&
            json.Address2 &&
            json.Postal &&
            json.City &&
            json.Postal.length === 6
        ) {
            return true;
        }
        return false;
    }, []);

    const setDeliveryAddress = useCallback(() => {
        setErrMsg('');
        if (!hasValidSessionKeys()) {
            setErrMsg('Session expired. Please reopen from verification link and try again.');
            return;
        }
        const createModel: Record<string, string | number> = {
            CustomerKey: String(customerKey).trim(),
            ValidatorKey: String(validatorKey).trim(),
            Title: title.trim(),
            Name: name.trim(),
            Address1: address1.trim(),
            Address2: address2.trim(),
            Postal: postal.trim(),
            City: area.trim(),
        };
        if (latitude && longitude) {
            createModel.Latitude = Number(latitude);
            createModel.Longitude = Number(longitude);
        }
        if (validate(createModel)) {
            props
                .setDelivery(createModel)
                .then((res: any) => {
                    const p = queryString.parse(location.search);
                    props.storeHashKey(res.value.data.PaymentHash, res.value.data.ReturnKey);
                    const search =
                        '?ath=true&share=true&uid=' +
                        firstQueryValue(p.uid) +
                        '&url=' +
                        firstQueryValue(p.url) +
                        '&PaymentHashToRedirctPaymentGate=' +
                        res.value.data.PaymentHash +
                        '&ReturnKey=' +
                        res.value.data.ReturnKey;
                    setTimeout(() => {
                        window.location.href =
                            '/pay' +
                            search +
                            '&totalAmount=' +
                            res.value.data.TotalAmount +
                            '&shippingCharge=' +
                            res.value.data.ShippingCharge;
                    }, 1000);
                })
                .catch((res: any) => {
                    const apiError = res?.response?.data?.title || res?.message || 'Unable to add address.';
                    setErrMsg(apiError);
                    console.log(res);
                });
        } else {
            setIsSubmit(true);
            setErrMsg('Please fill all required fields correctly.');
        }
    }, [
        props,
        customerKey,
        validatorKey,
        title,
        name,
        address1,
        address2,
        postal,
        area,
        latitude,
        longitude,
        location.search,
        validate,
        hasValidSessionKeys,
    ]);

    const onFocusHandler = useCallback(() => {
        setIsKeyboardOpen(true);
        window.scrollBy(0, 500);
    }, []);

    const onBlurHandler = useCallback(() => {
        setIsKeyboardOpen(false);
        window.scrollBy(0, 0);
    }, []);

    return (
        <div>
            <div className="Card-container">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                        <div className="card">
                            <div className="card-body rewardCard">
                                {/* <div className="cart-header"> */}
                                    <div className="flex-row"></div>

                                    <div className="flex-row" style={{ padding: '4px 0px 10px' }}>
                                        <div className="card-text F1 Fw Lh-2">Address</div>
                                        <div className="card-text F1 Fw Lh-2"></div>
                                        <div className="card-text F1 Fw Lh-2">{}</div>
                                    </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <section className={isKeyboardOpen ? 'addressSection' : 'addressSection-na'}>
                    {errMsg ? (
                        <div className="card-text F5" style={{ color: '#d21c1c', marginBottom: '10px' }}>
                            {errMsg}
                        </div>
                    ) : null}
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3 no-Pd" style={{ borderRadius: '4px', width: '25%' }}>
                            <div>Title</div>
                            <select
                                style={!title && isSubmit ? { borderColor: 'red' } : {}}
                                id="selectVendorLabel"
                                className="Select-drpdwn-new-card height-30"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Miss">Miss</option>
                            </select>
                        </div>
                        <div className="col-sm-9 col-md-9 col-lg-9 no-Pd" style={{ width: '75%' }}>
                            <div>Name</div>
                            <input
                                type="text"
                                placeholder="First & Last Name"
                                maxLength={30}
                                id="name"
                                data-test-id="name-input-box"
                                style={!name && isSubmit ? { borderColor: 'red' } : {}}
                                value={name}
                                className={'new-delivery-address_area addInput'}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                            <div className="new-delivery-address__form-row">
                                <div>Flat / House / Office No.</div>

                                <input
                                    type="text"
                                    maxLength={15}
                                    id="addressLine1"
                                    style={!address1 && isSubmit ? { borderColor: 'red' } : {}}
                                    className={'new-delivery-address_area addInput'}
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                            <div className="new-delivery-address__form-row">
                                <div>Street / Society / Office Name</div>

                                <input
                                    type="text"
                    maxLength={200}
                    value={address2}
                                    id="addressLine2"
                                    onChange={(e) => setAddress2(e.target.value)}
                                    style={!address2 && isSubmit ? { borderColor: 'red' } : {}}
                                    className={'new-delivery-address_area addInput'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                            <div className="new-delivery-address__form-row">
                                <div>Locality</div>
                                <input
                                    type="text"
                    maxLength={200}
                    id="addressLine3"
                                    value={area}
                                    onChange={(e) => setArea(e.target.value)}
                                    style={!area && isSubmit ? { borderColor: 'red' } : {}}
                                    className={'new-delivery-address_area addInput'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                            <div className="new-delivery-address__form-row">
                                <div>Pincode</div>

                                <input
                                    type="text"
                    maxLength={6}
                    id="addressLine4"
                                    value={postal}
                                    onFocus={onFocusHandler}
                                    onBlur={onBlurHandler}
                                    onChange={(e) => setPostal(e.target.value)}
                                    style={postal.length !== 6 && isSubmit ? { borderColor: 'red' } : {}}
                                    className={'new-delivery-address_area addInput'}
                                    onInput={(e) => {
                                        const el = e.currentTarget;
                                        el.value = el.value.replace(/[^0-9]/g, '').slice(0, 6);
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <br />
                </section>
                <footer>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <button
                            type="submit"
                            className="BuyBtnFooter primaryColor-ph2 "
                            onClick={setDeliveryAddress}
                        >
                            Add Address
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setDelivery,
            storeHashKey,
        },
        dispatch,
    );
};

// #endregion

export default compose(connect(null, mapDispatchToProps), withRouter)(AddressForm);
